module.exports = __webpack_public_path__ + "static/media/ios-open.2560c62b.svg";